import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { rodeoExpenseItems } from 'model/rodeoExpenseItems';


@Injectable()
export class ExpenseItemService {
    constructor(private api: ApiService) { }

    getRodeoExpensesItems(rodeoId:number) : Promise<rodeoExpenseItems[]> {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.expenseItems + '/GetAllRodeoExpenseItemsAsync/' + rodeoId)
                .then(data => resolve(data as rodeoExpenseItems[]), error => reject(error));
        });
    }

    createExpenseItem(expense: rodeoExpenseItems) : Promise<rodeoExpenseItems> {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.expenseItems, expense)
                .then(data => resolve(data as rodeoExpenseItems), error => reject(error));
        });
    }

    updateExpenseItem(expense: rodeoExpenseItems) {
        return new Promise((resolve, reject) => {
            this.api
                .putWithAuth(this.api.endpoints.expenseItems, expense)
                .then(data => resolve(data), error => reject(error));
        });
    }

    deleteExpenseItem(expenseId: number) {
        return new Promise((resolve, reject) => {
            this.api
            .deleteWithAuth(this.api.endpoints.expenseItems + '/DeleteRodeoExpenseItem/' + expenseId)
                .then(data => resolve(data), error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/ExpensesItems.service.ts